const selectLoader = (state) => state.settings.notifications.editor.loader
const selectError = (state) => state.settings.notifications.editor.error
const selectRecipientsSelectorData = (state) =>
  state.settings.notifications.editor.recipientsSelectorData
const selectRecipients = (state) => state.settings.notifications.editor.recipients
const selectRecipientsSearchFilter = (state) =>
  state.settings.notifications.editor.recipientsSearchFilter
const selectHasChangedRecipientsField = (state) =>
  state.settings.notifications.editor.hasChangedRecipientsField

export {
  selectLoader,
  selectError,
  selectRecipientsSelectorData,
  selectRecipients,
  selectRecipientsSearchFilter,
  selectHasChangedRecipientsField,
}
